import React, { useEffect, useState } from "react";
import "react-toastify/dist/ReactToastify.css";
import { QueryClient, QueryClientProvider } from "react-query";
import Favicon from "react-favicon";
import { ActiveMenuProvider } from "./context/ActiveMenuContext";
import Routes from "./routes";
import defaultLogoFavicon from "./assets/fluyra-favicon.png";
import api from "./services/api";
import { FluyraThemeProvider } from "./theme/ThemeProvider";

const queryClient = new QueryClient();

const App = () => {
  const [, setLocale] = useState("pt-BR");

  useEffect(() => {
    const i18nlocale = localStorage.getItem("i18nextLng");
    setLocale(i18nlocale || "pt-BR");
  }, []);

  useEffect(() => {
    async function fetchVersionData() {
      try {
        const response = await api.get("/version");
        window.localStorage.setItem("frontendVersion", response.data.version);
      } catch (error) {
        console.log("Error fetching data", error);
      }
    }

    fetchVersionData();
  }, []);

  return (
    <>
      <Favicon url={defaultLogoFavicon} />
      <FluyraThemeProvider>
        <QueryClientProvider client={queryClient}>
          <ActiveMenuProvider>
            <div style={{ position: "relative", overflow: "visible", zIndex: 0, minHeight: "100vh" }}>
              <Routes />
            </div>
          </ActiveMenuProvider>
        </QueryClientProvider>
      </FluyraThemeProvider>
    </>
  );
};

export default App;
